import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import OrderServices from "./OrderServices";

const initialState = {
  order: null,
  orders: [],
  orderLast30Day: [],
  reportByDate: [],
  reportByDateDetail: [],
  pendingOrders: [],
  pendingOrdersForupdate: [],
  isError: false,
  isSuccess: false,
  isSuccessCreate: false,
  isSuccessPrint: false,
  isSuccessFreeOrder: false,
  isSuccessComplete: false,
  isSuccessUpdate: false,
  isSuccessChangeTable: false,
  isLoading: false,
  isLoadingReport: false,
  message: "",
};

// createOrder thunkApi
export const createOrder = createAsyncThunk(
  "order/createOrder",
  async (orderData, thunkAPI) => {
    try {
      return await OrderServices.createOrder(orderData);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getOrders = createAsyncThunk(
  "order/getOrders",
  async (_, thunkAPI) => {
    try {
      return await OrderServices.getOrders();
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getOrderLast30Day = createAsyncThunk(
  "order/getOrderLast30Day",
  async (_, thunkAPI) => {
    try {
      return await OrderServices.getOrderLast30Day();
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getPendingOrders = createAsyncThunk(
  "order/getPendingOrders",
  async (_, thunkAPI) => {
    try {
      return await OrderServices.getPendingOrders();
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getPendingOrdersForupdate = createAsyncThunk(
  "order/getPendingOrdersForupdate",
  async (_, thunkAPI) => {
    try {
      return await OrderServices.getPendingOrdersForupdate();
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const updateOrderStatus = createAsyncThunk(
  "order/updateOrderStatus",
  async ({ updateOrderData, id }, thunkAPI) => {
    try {
      return await OrderServices.updateOrderStatus({ updateOrderData, id });
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const changeTable = createAsyncThunk(
  "order/changeTable",
  async ({ newTableNo, orderId }, thunkAPI) => {
    try {
      return await OrderServices.changeTable({ newTableNo, orderId });
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const updateOrder = createAsyncThunk(
  "order/updateOrder",
  async (updateOrderData, thunkAPI) => {
    try {
      return await OrderServices.updateOrder(updateOrderData);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const updateOrderDiscount = createAsyncThunk(
  "order/updateOrderDiscount",
  async ({ totalAmountDiscount, discountReason, id, service }, thunkAPI) => {
    try {
      return await OrderServices.updateOrderDiscount({
        totalAmountDiscount,
        discountReason,
        id,
        service,
      });
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const freeOrder = createAsyncThunk(
  "order/freeOrder",
  async ({ discountReason, id }, thunkAPI) => {
    try {
      return await OrderServices.freeOrder({
        discountReason,
        id,
      });
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const deleteOrder = createAsyncThunk(
  "order/deleteOrder",
  async (id, thunkAPI) => {
    try {
      return await OrderServices.deleteOrder(id);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getOrdersByDateTimeRange = createAsyncThunk(
  "order/getOrdersByDateTimeRange",
  async (orderData, thunkAPI) => {
    try {
      const response = await OrderServices.getOrdersByDateTimeRange(orderData);
      return response;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

const orderSlice = createSlice({
  name: "order",
  initialState,
  reducers: {
    RESETORDER(state) {
      state.isError = false;
      state.isSuccess = false;
      state.isLoading = false;
      state.isLoadingReport = false;
      state.isSuccessCreate = false;
      state.isSuccessPrint = false;
      state.isSuccessFreeOrder = false;
      state.isSuccessComplete = false;
      state.isSuccessUpdate = false;
      state.isSuccessChangeTable = false;
      state.message = "";
      state.reportByDate = [];
      state.reportByDateDetail = [];
    },
  },
  extraReducers: (builder) => {
    builder
      // create order
      .addCase(createOrder.pending, (state, action) => {
        state.isLoading = true;
      })

      .addCase(createOrder.fulfilled, (state, action) => {
        state.isLoading = false;
        state.order = action.payload;
        state.isSuccessCreate = true;
        toast.success("Create new order successfully");
      })

      .addCase(createOrder.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        state.order = null;
        toast.error(action.payload);
      })

      .addCase(getOrders.pending, (state, action) => {
        state.isLoading = true;
      })

      .addCase(getOrders.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.orders = action.payload.data;
      })

      .addCase(getOrders.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        state.orders = null;
        toast.error(action.payload);
      })

      .addCase(getOrderLast30Day.pending, (state, action) => {
        state.isLoading = true;
      })

      .addCase(getOrderLast30Day.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.orderLast30Day = action.payload.data;
      })

      .addCase(getOrderLast30Day.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        state.orderLast30Day = null;
        toast.error(action.payload);
      })

      .addCase(getPendingOrders.pending, (state, action) => {
        state.isLoading = true;
      })

      .addCase(getPendingOrders.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.pendingOrders = action.payload.data;
      })

      .addCase(getPendingOrders.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        state.pendingOrders = null;
        toast.error(action.payload);
      })

      .addCase(getPendingOrdersForupdate.pending, (state, action) => {
        state.isLoading = true;
      })

      .addCase(getPendingOrdersForupdate.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.pendingOrdersForupdate = action.payload.data;
      })

      .addCase(getPendingOrdersForupdate.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        state.pendingOrdersForupdate = null;
        toast.error(action.payload);
      })

      .addCase(updateOrderStatus.pending, (state, action) => {
        state.isLoading = true;
      })

      .addCase(updateOrderStatus.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isSuccessComplete = true;
        state.order = action.payload.data;
        toast.success(action.payload.message);
      })

      .addCase(updateOrderStatus.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.order = action.payload;
        toast.error(action.payload);
      })

      .addCase(changeTable.pending, (state, action) => {
        state.isLoading = true;
      })

      .addCase(changeTable.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccessChangeTable = true;
        state.order = action.payload.data;
        toast.success(action.payload.message);
      })

      .addCase(changeTable.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        toast.error(action.payload);
      })

      .addCase(updateOrder.pending, (state, action) => {
        state.isLoading = true;
      })

      .addCase(updateOrder.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccessUpdate = true;
        state.order = action.payload.data;
        toast.success(action.payload.message);
      })

      .addCase(updateOrder.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.order = action.payload;
        toast.error(action.payload);
      })

      .addCase(updateOrderDiscount.pending, (state, action) => {
        state.isLoading = true;
      })

      .addCase(updateOrderDiscount.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.order = action.payload.data;
        state.isSuccessPrint = true;
        // toast.success(action.payload);
      })

      .addCase(updateOrderDiscount.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.order = null;
        state.message = action.payload;
        toast.error(action.payload);
      })

      .addCase(freeOrder.pending, (state, action) => {
        state.isLoading = true;
      })

      .addCase(freeOrder.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.order = action.payload.data;
        state.isSuccessFreeOrder = true;
      })

      .addCase(freeOrder.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.order = null;
        state.message = action.payload;
        toast.error(action.payload);
      })

      .addCase(deleteOrder.pending, (state, action) => {
        state.isLoading = true;
      })

      .addCase(deleteOrder.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        toast.success(action.payload);
      })

      .addCase(deleteOrder.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        toast.error(action.payload);
      })

      .addCase(getOrdersByDateTimeRange.pending, (state, action) => {
        state.isLoadingReport = true;
      })

      .addCase(getOrdersByDateTimeRange.fulfilled, (state, action) => {
        state.isLoadingReport = false;
        state.isSuccess = true;
        state.reportByDate = action.payload.reportData;
        state.reportByDateDetail = action.payload.detailReportData;
      })

      .addCase(getOrdersByDateTimeRange.rejected, (state, action) => {
        state.isLoadingReport = false;
        state.isError = true;
        state.message = action.payload;
        state.reportByDate = null;
        state.reportByDateDetail = null;
        toast.error(action.payload);
      });
  },
});

export const { RESETORDER } = orderSlice.actions;
export const selectOrder = (state) => state.order.order;
export const selectOrderLoading = (state) => state.order.isLoadingReport;
export const selectOrders = (state) => state.order.orders;
export const selectOrderLast30Day = (state) => state.order.orderLast30Day;
export const selectOrderByDate = (state) => state.order?.reportByDate;
export const selectOrderByDateDetail = (state) =>
  state.order?.reportByDateDetail;
export const selectPendingOrders = (state) => state.order?.pendingOrders;
export const selectPendingOrdersForupdate = (state) =>
  state.order?.pendingOrdersForupdate;
export const selectOrderSuccess = (state) => state.order.isSuccessCreate;
export const selectOrderSuccessPrint = (state) => state.order.isSuccessPrint;
export const selectOrderSuccessComplete = (state) =>
  state.order.isSuccessComplete;
export const selectOrderSuccessUpdate = (state) => state.order.isSuccessUpdate;
export const selectSuccessChangeTable = (state) =>
  state.order.isSuccessChangeTable;
export const selectSuccessFreeOrder = (state) => state.order.isSuccessFreeOrder;

export default orderSlice.reducer;
